module.exports = __webpack_public_path__ + "static/media/34DSS4.cf46cf75.jpg";